import React from 'react';
import TabPanel from './tab-panel';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'

const text = `
# Setup

Download using the link above or see option 2 or 3 below to download in developer mode.

### Pin the extension
Pin this extension in the extensions drop down at the top right of the chrome tool bar like below
![Extension_list_image](https://i.imgur.com/E27Plzy.png)

### Create a key shortcut
I also recommend creating a shortcut to access the extension more easily.
You can do this easily by going to [chrome://extensions/shortcuts](chrome://extensions/shortcuts) and typing a shortcut for Tabs Collage. E.g. Alt-C

### Activating the extension
Either use the shortcut you created above or click on the Tabs collage icon to open the extension page. Note: you can click this icon to easily get back to the extension page
![Tabs_Collage_Icon_Pinned](https://i.imgur.com/d6ftZUV.png)

Note: If there are tabs that existed before the extension was installed or tabs were restored from a previous session there will be loading window.

### Option 2: Load the build folder into chrome 

1. [Download](https://github.com/ProfessorX737/tabs-collage/releases/download/v1.0.1/tabs-collage.zip) the zip file 
2. Unzip the file. This should produce a folder called 'build'
3. Go to [chrome://extensions/](chrome://extensions/)
4. Turn on developer mode switch at the top right of the page
5. Click 'Load unpacked' button and select the build folder that you extracted
![load_unpacked_image](https://i.imgur.com/xRSA7ZQ.png)

For more download options see the [release versions](https://github.com/ProfessorX737/tabs-collage/releases).

### Option 3: Clone the project and build with yarn
If you want to make your own modifications or option 1 is not working you can use option 2.

1. Install yarn and nodejs
2. Clone the project at https://github.com/ProfessorX737/tabs-extension
3. Type 'yarn install' in the project directory
4. Type 'yarn build' in the project directory. This should create a build folder
5. Go to 'chrome://extensions/' and turn on 'Developer mode' at the top right
6. Click 'Load unpacked' and select the build folder that was created in step 4
7. Click on 'Tabs Collage' in the extensions drop down at the top right of the chrome tool bar

### Troubleshooting:
- If you are restoring your chrome session your tabs may not be loaded so there will be no images shown. You may have to refresh the extension a few times.
- If the extension is not updating try clicking the associated extension icon to activate it.
- If there any sites that start with 'https://' or 'http://' and the image for that site is not found try refreshing the extension.

`

export default function Download(props) {
	return (
		<TabPanel
			currTabIndex={props.currTabIndex}
			tabIndex={props.tabIndex}
		>
			<ReactMarkdown source={text} />
		</TabPanel>
	)
}

Download.propTypes = {
	currTabIndex: PropTypes.any.isRequired,
	tabIndex: PropTypes.any.isRequired
}

